module.exports = __webpack_public_path__ + "static/media/highlight-c.a56719b5.jpg";